import { HttpTypes } from '@/types';
import { ICategoryTree } from '@/types/category';
import { ILocationData } from '@/types/location';
import { IProduct } from '@/types/general';
import { AxiosInstance } from 'axios';
import { CreateInvoicePayload, CreateInvoiceResponse } from '@/types/http/domain';
import { IPaymentChannels } from '@/types/payment';

class GeneralSetting {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getGlobalSetting(): Promise<HttpTypes.IResponse<HttpTypes.AdminGlobalSettingResponse>> {
    const result = await this.client.get(`/sites/global-setting`);
    return result.data;
  }

  async listCategoryOmni(
    query: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<ICategoryTree[]>> {
    const result = await this.client.get('/sites/category-omni', {
      params: query,
    });
    return result.data;
  }

  async listCatalogOmni(
    query: HttpTypes.FindParams & {
      categoryIds?: string[];
    }
  ): Promise<HttpTypes.IResponse<IProduct[]>> {
    const result = await this.client.get('/sites/catalog-omni', { params: query });
    return result.data;
  }

  async listActiveLocationOmni(
    query: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<ILocationData[]>> {
    const result = await this.client.get('/sites/location/active-omni', { params: query });
    return result.data;
  }

  async createDomainvoice(
    data: CreateInvoicePayload
  ): Promise<HttpTypes.IResponse<CreateInvoiceResponse>> {
    const response = await this.client.post('/sites/payment/buy-domain', data);
    return response.data;
  }

  async listPaymentMethod(): Promise<HttpTypes.IResponse<IPaymentChannels[]>> {
    const result = await this.client.get('/sites/payment-channel');
    return result.data;
  }

  async checkDomain(params: HttpTypes.FindParams): Promise<HttpTypes.DomainCheckResponse> {
    const result = await this.client.get(`/sites/subdomain/check`, { params });
    return result.data;
  }

  async getStoreProgress(
    data: HttpTypes.AdminStoreProgressParams
  ): Promise<HttpTypes.AdminStoreProgressResponse> {
    const result = await this.client.post(`/sites/progress`, data);
    return result.data;
  }

  async listCategory(
    queryparams: HttpTypes.FindParams
  ): Promise<HttpTypes.AdminCategoriesResponse> {
    const result = await this.client.get(`/sites/categories`, {
      params: queryparams,
    });
    return result.data;
  }
}

export default GeneralSetting;
